import { signal } from '@angular/core';

export class FlowpilotPopUpService {
  /****/
  private readonly _menuOpen = signal(false);

  public set menuOpen(value: boolean) {
    this._menuOpen.set(value);
  }

  public get menuOpenSignal() {
    return this._menuOpen.asReadonly();
  }
}
